import Vue from 'vue'

import User from './services/user'  // 首页
import paymentRegulate from './services/payment-regulate' // 支付管理
import taskManager from './services/task-manager' // 任务管理
import individualCenter from './services/individual-center' // 商户中心
import expenseRegulate from './services/expense-regulate'  // 费用管理
import invoiceRegulate from './services/invoice-regulate'  // 发票管理
import receiptRegulate from './services/receipt-regulate'  // 税单管理/系列日志
import statementAccount from './services/statement-account' // 对账单

Vue.prototype.service = {
    User,
    paymentRegulate,
    taskManager,
    individualCenter,
    expenseRegulate,
    invoiceRegulate,
    receiptRegulate,
    statementAccount
}



// WEBPACK FOOTER //
// ./src/service/index.js